import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProjectData } from '../models/projectdata';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  //baseurl: string = "https://localhost:44314/api/CustomerSurvey";
  baseurl: string = "https://webapi-ext.gocomp.net/api/CustomerSurvey";

  constructor(private http: HttpClient) {  }

  getCsData(id: string) {
    return this.http.get<ProjectData>(`${this.baseurl}/GetCsDataForFrontend?csId=${id}&logoSize=${'M'}`);
  }

  saveCsAnswers(postData: any) {
    return this.http.post<boolean>(`${this.baseurl}/SaveCsAnswers`, postData);
  }
}
